
import { useParams } from "react-router-dom";
import React,{useState,useEffect} from 'react'
import { collection, query, where,getDocs } from "firebase/firestore";
import { db } from '../auth/UsersConfig/Authfirebase';
import Item from "./Item";
import '.././Home.css'
const VerxCategoria = () => {
    const { IdCat } = useParams();
    const [datproducts, setDatproducts]=useState([]);
    
    const GetAllproducts=async()=>{
        const  Myproducts=collection(db, "products");
      
        const Query = query(Myproducts,where("Activo", "==",true),where("Cat", "==",IdCat));
        const Data = await getDocs(Query);
        const data = Data.docs
        .map(doc => ({
          id: doc.id,
          nombre: doc.data().nombre,
          desc: doc.data().desc,
          price: doc.data().price,
          co_price: doc.data().comparePrice,
          Img: doc.data().Img,
          Cat:doc.data().CatName,
        }));
  setDatproducts(data);
  console.log(data);
      }
      useEffect(() => {
        GetAllproducts();
      
      }, []);
  return (
    <div style={{width:'100%'}}>
      <h3 style={{textAlign:'center',width:'100%',marginBottom:5}}> {datproducts.length>0? datproducts[0].Cat:''}</h3>
      <div className="containerItems">
      {datproducts?.map(product => (
        <Item detalle={product} key={product.id} className="item" />
      ))}
</div>
    </div>
  );
};

export default VerxCategoria;
